import serialize from "json-form-data";
import {addAuthKey} from '@/helpers/addAuthKeyToUrl';
const api_url = "/index.php";

const state = () => ({
    analyseGroups: []
});

const actions = {
    async createAnalyseType({ dispatch, rootState }, params) {
        const token = rootState.authToken;
        const formData = serialize(params.data);

        await fetch(
            addAuthKey(`${api_url}/?r=api/medical-analysis-types/create`, token),
            {
                method: "POST",
                body: formData
            }
        );
        await dispatch("medicalAnalysesForm/fetchAnalysesTypes", null, { root: true });
    },
    updateAnalyseType({ rootState }, { data, id }) {
        const token = rootState.authToken;
        const formData = serialize(data);

        return fetch(
            addAuthKey(`${api_url}/?r=api/medical-analysis-types/update&id=${id}`, token),
            {
                method: "POST",
                body: formData
            }
        );
    },
    deleteAnalyseType({ rootState }, typeId) {
        const token = rootState.authToken;

        return fetch(addAuthKey(`${api_url}/?r=api/medical-analysis-types/delete&id=${typeId}`, token));
    },
    async fetchAllAnalyzes({ rootState }) {
        const token = rootState.authToken;
        const res = await fetch(addAuthKey(`${api_url}/?r=api/medical-analysis-types/index`, token));
        const json = await res.json();

        return json;
    },
    deleteAnalyse({ rootState }, id) {
        const token = rootState.authToken;
        return fetch(
            addAuthKey(`${api_url}/?r=api/medical-analysis/delete&id=${id}`, token),
            {
                method: "DELETE"
            }
        );
    },
    resort({ rootState }, { list, id}) {
        const token = rootState.authToken;
        const formData = JSON.stringify(list);

        return fetch(
            addAuthKey(`${api_url}/?r=api/medical-analysis-types/update-sort&id=${id}`, token),
            {
                method: "PUT",
                body: formData,
                headers: {
                    "Content-Type": "application/json"
                },
            }
        );
    }
};

export default {
    namespaced: true,
    state,
    actions
};
